// useCurrentBreakpoint.tsx 
import { Breakpoint, useMediaQuery, useTheme } from "@mui/material";
import { UADataValues } from "../../../tools/collectClientHints";

interface NavigatorUAData extends UADataValues {
  getHighEntropyValues(hints: string[]): Promise<UADataValues>;
}

interface NavigatorWithUA extends Navigator {
  userAgentData?: NavigatorUAData;
}

export function useCurrentBreakpoint(): Breakpoint {
  const theme = useTheme();
  const isXl = useMediaQuery(theme.breakpoints.up('xl'));
  const isLg = useMediaQuery(theme.breakpoints.up('lg'));
  const isMd = useMediaQuery(theme.breakpoints.up('md'));
  const isSm = useMediaQuery(theme.breakpoints.up('sm'));

  if (isXl) return 'xl';
  if (isLg) return 'lg';
  if (isMd) return 'md';
  if (isSm) return 'sm';
  return 'xs';
}

/**
 * Асинхронный сбор данных браузера
 */
async function collectClientHints() {
  const nav = navigator as NavigatorWithUA;
  const res: any = {
    userAgent: nav.userAgent,
    language: nav.language,
    platform: nav.platform,
  };

  if (nav.userAgentData) {
    try {
      const highEntropy = await nav.userAgentData.getHighEntropyValues([
        'architecture',
        'bitness',
        'model',
        'platformVersion',
        'fullVersionList',
      ]);
      
      // Превращаем массивы брендов в читаемые строки для БД
      const parseBrands = (list?: { brand: string; version: string }[]) => 
        list?.map(b => `${b.brand} (v${b.version})`).join(', ');

      return {
        ...res,
        browserBrands: parseBrands(nav.userAgentData.brands),
        browserFullVersions: parseBrands(highEntropy.fullVersionList),
        isMobile: nav.userAgentData.mobile,
        osPlatform: nav.userAgentData.platform,
        osVersion: highEntropy.platformVersion,
        arch: highEntropy.architecture,
        model: highEntropy.model,
        bitness: highEntropy.bitness,
      };
    } catch (e) {
      console.warn("UA-CH failed", e);
    }
  }
  return res;
}
